module.exports = __webpack_public_path__ + "img/autosense-landing-page.80677e80.png";